var map = {
	"./afb-color.svg": 641,
	"./alb-color.svg": 642,
	"./all.svg": 643,
	"./amb-color.svg": 644,
	"./arg.svg": 645,
	"./aus.svg": 646,
	"./bank-icon.svg": 647,
	"./bankdemo-color.svg": 648,
	"./bel.svg": 649,
	"./bimb-color.svg": 650,
	"./bkr-color.svg": 651,
	"./bpay-color.svg": 652,
	"./bra.svg": 653,
	"./bsn-color.svg": 654,
	"./can.svg": 655,
	"./checked-white.png": 656,
	"./cimb-color.svg": 657,
	"./cimb-icon.svg": 658,
	"./citi-color.svg": 659,
	"./cmr.svg": 660,
	"./crc.svg": 661,
	"./cro.svg": 662,
	"./den.svg": 663,
	"./ecu.svg": 664,
	"./eng.svg": 665,
	"./esp.svg": 666,
	"./esports-active-m.svg": 667,
	"./esports-m.svg": 668,
	"./fav-gray.png": 669,
	"./fav-icon-active.png": 670,
	"./fav-icon.png": 671,
	"./fav-red.png": 672,
	"./fra.svg": 673,
	"./game-icon.svg": 674,
	"./games-active-m.svg": 675,
	"./games-m.svg": 676,
	"./ger.svg": 677,
	"./gha.svg": 678,
	"./gxbank-color.svg": 679,
	"./hlb-color.svg": 680,
	"./hlb-icon.svg": 681,
	"./hsbc-color.svg": 682,
	"./irn.svg": 683,
	"./jpn.svg": 684,
	"./kor.svg": 685,
	"./ksa.svg": 686,
	"./kwh-color.svg": 687,
	"./latest-icon-active.png": 688,
	"./latest-icon.png": 689,
	"./lc-active-m.svg": 690,
	"./lc-icon.svg": 691,
	"./lc-m.svg": 692,
	"./lottery-active-m.svg": 693,
	"./lottery-icon.svg": 694,
	"./lottery-m.svg": 695,
	"./love.svg": 696,
	"./mar.svg": 697,
	"./mbb-color.svg": 698,
	"./mex.svg": 699,
	"./ned.svg": 700,
	"./ocbc-color.svg": 701,
	"./ocbc-icon.svg": 702,
	"./p2p-active-m.svg": 703,
	"./p2p-icon.svg": 704,
	"./p2p-m.svg": 705,
	"./pbb-color.svg": 706,
	"./pol.svg": 707,
	"./por.svg": 708,
	"./price-high.svg": 709,
	"./price-low.svg": 710,
	"./qat.svg": 711,
	"./rhb-color.svg": 712,
	"./rhb-icon.svg": 713,
	"./scb-color.svg": 714,
	"./sen.svg": 715,
	"./slot-active-m.svg": 716,
	"./slot-icon.svg": 717,
	"./slot-m.svg": 718,
	"./speed-active-m.svg": 719,
	"./speed-m.svg": 720,
	"./sport-active-m.svg": 721,
	"./sport-m.svg": 722,
	"./sports-icon.svg": 723,
	"./square-icon.svg": 724,
	"./srb.svg": 725,
	"./star.svg": 726,
	"./sui.svg": 727,
	"./tng-color.svg": 728,
	"./trx-icon.svg": 729,
	"./trx.svg": 730,
	"./tun.svg": 731,
	"./uefa-icon.svg": 732,
	"./uob-color.svg": 733,
	"./uru.svg": 734,
	"./usa.svg": 735,
	"./usdc.svg": 736,
	"./usdt.svg": 737,
	"./ustd-icon.svg": 738,
	"./wal.svg": 739,
	"./x33-logo-b.svg": 740,
	"./x33-square-icon.svg": 741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;